import { Link } from 'react-router-dom';
import { LANDING_CONTENT } from '../content';

// Intrinsic size of the asset, declared so the frame reserves space before it loads.
const SHOT_WIDTH = 1268;
const SHOT_HEIGHT = 514;

/** A real dashboard screenshot, set in a light browser frame. */
function ProductPanel() {
  return (
    <div className="landing-panel">
      <div className="landing-panel-chrome" aria-hidden="true">
        <span className="landing-panel-dot" />
        <span className="landing-panel-dot" />
        <span className="landing-panel-dot" />
      </div>

      <img
        className="landing-panel-shot"
        src="/landing/hero-dashboard.webp"
        alt={LANDING_CONTENT.hero.screenshotAlt}
        width={SHOT_WIDTH}
        height={SHOT_HEIGHT}
        loading="eager"
        decoding="async"
      />
    </div>
  );
}

export default function LandingHero() {
  const { eyebrow, title, lede, cta } = LANDING_CONTENT.hero;

  return (
    <section className="landing-hero">
      <div className="landing-container landing-hero-inner">
        <p className="landing-eyebrow">{eyebrow}</p>
        <h1 className="landing-hero-title">{title}</h1>
        <p className="landing-hero-lede">{lede}</p>
        <Link to="/login" className="btn btn-primary landing-hero-cta">
          {cta}
        </Link>
      </div>

      <div className="landing-container">
        <ProductPanel />
      </div>
    </section>
  );
}
